import theme from "@monorepo/styles/theme";
import { styled } from "@mui/material/styles";

export const SEmptyPage = styled("div")(() => ({
  display: "grid",
  alignContent: "center",
  justifyContent: "center",
  justifyItems: "center",
  gridAutoFlow: "row",
  rowGap: theme.spacing(3),
}));
